module.exports = __webpack_public_path__ + "img/4a14999.jpg";